import { cn } from "@/lib/utils";

const MAP = {
  info: "border-sev-info/40 bg-sev-info/10 text-sev-info",
  success: "border-sev-success/40 bg-sev-success/10 text-sev-success",
  warning: "border-sev-warning/40 bg-sev-warning/10 text-sev-warning",
  danger: "border-sev-danger/40 bg-sev-danger/10 text-sev-danger",
  neutral: "border-border bg-muted text-muted-foreground",
};

const STATUS_TO_SEV = {
  healthy: "success", sanctioned: "success", live: "success", approved: "success", complete: "success", ok: "success",
  degraded: "warning", tolerated: "warning", staged: "warning", pending: "warning", "in progress": "warning", investigating: "warning",
  failed: "danger", blocked: "danger", block: "danger", denied: "danger", new: "danger",
  draft: "neutral", observe: "neutral", allow: "success", coach: "info", redact: "warning",
};

export const SeverityChip = ({ level, label, className, dot = false, ...rest }) => {
  const key = (level || "neutral").toString().toLowerCase();
  const sev = MAP[key] ? key : STATUS_TO_SEV[key] || "neutral";
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize", MAP[sev], className)} {...rest}>
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" />}
      {label ?? level}
    </span>
  );
};
